__webpack_require__.p = "https://bmidxbcroatiaplprod.netlify.app/";